import { render, staticRenderFns } from "./ReferenceModal.vue?vue&type=template&id=21b1cfd4&"
import script from "./ReferenceModal.vue?vue&type=script&lang=js&"
export * from "./ReferenceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports